import { DEFAULT_BREAKPOINTS, TILE_BREAKPOINTS } from './Swimlane.sizes';
import { TILE_COMPONENT_TYPES } from '../TileComponent/TileComponent.const';
import { mediaQuery, breakpoints as BREAKPOINTS } from 'components/theme/breakpoints';

const generateBreakpoints = () => {
  const retVal = {};
  Object.values(TILE_COMPONENT_TYPES).forEach((tile) => {
    retVal[tile] = {};
    let minWidth = 0;
    let size = 0;

    const breakpoints = {
      ...DEFAULT_BREAKPOINTS,
      ...TILE_BREAKPOINTS[tile],
    };

    Object.keys(breakpoints).forEach((breakpoint) => {
      size = breakpoints[breakpoint];
      const maxWidth = BREAKPOINTS[breakpoint];

      // Base on tile breakpoints set what size will ti be between breakpoints
      const key = mediaQuery.betweenWidth(minWidth, maxWidth);

      retVal[key] = {
        // Include other tile breakpoints
        ...retVal[key],

        // Create new size for tile
        [tile]: {
          minWidth: `${size}%`,
          maxWidth: `${size}%`,
        },
      };
      // set current maxWidth as next min width for next breakpoint
      minWidth = maxWidth;
    });

    // set tile size for larger screens
    retVal[mediaQuery.minWidth(minWidth)] = {
      ...retVal[mediaQuery.minWidth(minWidth)],
      [tile]: {
        minWidth: `${size}%`,
        maxWidth: `${size}%`,
      },
    };
  });

  return retVal;
};

export default {
  swimlane: {
    '&:hover > div[data-testid*="swimlane-arrow"]': {
      display: 'flex',
    },
  },
  wrapper: {
    position: 'relative',
    overflow: 'scroll',
    overflowY: 'hidden',
    'scroll-behavior': 'smooth',
    marginRight: -40,
    paddingRight: 40,
    marginLeft: -45,
    paddingLeft: 45,
    '-ms-overflow-style': 'none',
    'scrollbar-width': 'none',
    '&:before, &:after': {
      content: '""',
      display: 'block',
      minWidth: 40,
    },
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  [mediaQuery.maxWidth(BREAKPOINTS.sm)]: {
    wrapper: {
      marginRight: -20,
      paddingRight: 20,
      marginLeft: -15,
      paddingLeft: 15,
      '&:before, &:after': {
        content: '""',
        display: 'block',
        minWidth: 20,
      },
    },
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
  },
  items: {
    display: 'flex',
  },
  item: {
    display: 'relative',
    padding: 5,
    transition: '250ms all',
  },
  ...generateBreakpoints(),
};
